module.exports = __webpack_public_path__ + "img/replay-orchard.07674826.svg";